import React, { Component } from 'react';
import './../../css/LoaderIcon.css';


class SVG extends Component {
    componentDidMount = () => {

    }
    render() {
        return(
            <svg>
                <circle className="path" style={{fill: 'none', stroke: 'black', strokeWidth: 5, strokeDashoffset: 0}} r={15} cx={15} cy={15}></circle>  
            </svg>
        )
    }
}
export default SVG;


// WEBPACK FOOTER //
// ./src/js/src/LoaderIcon.js